import "./BNGUnitsKPI.css";

import { formatNumber } from "../../../../utils";
import { GenericTooltip } from "../../../forms";

interface BNGUnitsKPIProps {
  areaHabitatUnits: number;
  hedgerowUnits: number;
  watercourseUnits: number;
}

export const BNGUnitsKPI = ({ areaHabitatUnits, hedgerowUnits, watercourseUnits }: BNGUnitsKPIProps): JSX.Element => {
  // Alphabetical by unit type, matching the server-side `quantity_type` ordering (BR-02857).
  // Each type keeps a fixed shade so a band reads the same whichever types a project has.
  const unitTypes = [
    { shade: "AreaHabitat", label: "Area habitat", units: areaHabitatUnits },
    { shade: "Hedgerow", label: "Hedgerow", units: hedgerowUnits },
    { shade: "Watercourse", label: "Watercourse", units: watercourseUnits },
  ].filter(({ units }) => units > 0);

  const total = unitTypes.reduce((sum, { units }) => sum + units, 0);

  return (
    <div className="BNGUnitsContainer">
      <div className="BNGUnitsGraph">
        {unitTypes.map(({ shade, label, units }) => (
          <GenericTooltip
            key={label}
            placement="right"
            content={
              <div className="BNGUnitsTooltipContainer">
                <p className="body3">{label}</p>
              </div>
            }
          >
            <div className={`BNGUnitsGraphBand ${shade}`} style={{ flex: (units / total) * 100 }} />
          </GenericTooltip>
        ))}
      </div>
      <div className="BNGUnitsHeaderArea">
        {unitTypes.map(({ label, units }) => (
          <div className="BNGUnitsType" key={label}>
            <h2>{formatNumber(units)}</h2>
            <p className="body1">{label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
